(function () {
  var input = document.querySelector('[data-predictive-search-input]');
  var results = document.querySelector('[data-predictive-search-results]');
  if (!input || !results || !window.routes) return;
  var controller;
  var debounce;

  input.addEventListener('input', function () {
    clearTimeout(debounce);
    var term = input.value.trim();
    if (term.length < 2) {
      results.innerHTML = '';
      return;
    }
    debounce = setTimeout(function () {
      if (controller) controller.abort();
      controller = new AbortController();
      var url = window.routes.predictive_search_url + '?q=' + encodeURIComponent(term) + '&resources[type]=product,collection,page,article&resources[limit]=6&section_id=predictive-search';
      fetch(url, { signal: controller.signal })
        .then(function (response) { return response.text(); })
        .then(function (html) { results.innerHTML = html; })
        .catch(function () {});
    }, 180);
  });
})();
